
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gBR5x5APirfXnxUHz159vLvdW_45lIyQtD6bCnztrec_45uoMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexKtCvm5Jx0ia_45_qgqN26VURva3viNC3XTQJYXPXflXiYMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search1bDe_453_45J7BxzCgM6UYgf2p4Mowfg7Jup_45NAh9iTMiGwMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexTiBuqHqpbnQQQYlZBrfsjmz_ihZbpmYT6kp00zx3QsoMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_9353NB7DbQacCF_RFCC_YOEDIABvJxz3Mt80GylRO6J2wMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexW3Cga5sA9L2fmeabwwhe3iUY2qAuHEsuVgtIqfVtgwMMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93i86nHL1dSBUpsvx4p4_459RpP1qDP4VsZoBmpQ_pdP93cMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexRxJqJAFQLuoympCEjTbqTZxv5gr1X3oPD_mF1C3xEdAMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93D848qsvZox_7QWRPwoubMBoO17P455b47d0CDOrHStEMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexLpLM_ewmoKCy9b1r5ONbROOq6EmVq99OMivxlNn5u8cMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index2XOz_VuVLkLZODvkSEpYIs3IZasKgxmy2hP8vYSKUOMMeta } from "/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexW3Cga5sA9L2fmeabwwhe3iUY2qAuHEsuVgtIqfVtgwMMeta || {},
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexRxJqJAFQLuoympCEjTbqTZxv5gr1X3oPD_mF1C3xEdAMeta || {},
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexLpLM_ewmoKCy9b1r5ONbROOq6EmVq99OMivxlNn5u8cMeta || {},
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index2XOz_VuVLkLZODvkSEpYIs3IZasKgxmy2hP8vYSKUOMMeta || {},
    component: () => import("/codebuild/output/src2361372070/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]